module.exports = __webpack_public_path__ + "img/movil.36763f13.svg";